<template>
  <span>
    <div :class="{ 'text-danger': object.paid < 0 }">{{ formatCurrency(object.paid) }}</div>
    <div v-if="object.refunded_amount"
         class="text-danger small">
      {{ $t('return') }}: {{ formatCurrency(object.refunded_amount) }}
    </div>
  </span>
</template>

<script setup>
import { formatCurrency } from "@/extensions/filters/filters"

defineProps({
  object: {
    type: Object
  }
})
</script>
